<template>
  <div slot="body">
    <bita-form ref="form">
      <div slot="body">
        <div class="row" v-html="this.ruleText"></div>

        <input type="checkbox" class="mx-2 agree-rules-button" id="checkbox" v-model="form.accept" />
        <label for="checkbox">  قوانین فوق را مطالعه نموده و با آن موافقم  </label>

        <!-- <bita-checkbox
            name="accept_rule"
            rules="required"
            @change="AcceptRule"
            color="success"
            v-model="form.accept"
            label="پذیرش قوانین "
            :validation-container-class="colWidth"
            input-class="form-control"
          />       -->
      </div>
    </bita-form>
  </div>
</template>
<script>
import { supplireApi } from "@/api/apiManagement";
export default {
  props: {
    title: String,
    isLoading: Boolean,
    largeColWidth: {
      default: "col-lg-3",
    },
    smallColWidth: {
      default: "col-lg-2",
    },
    product: {},
  },
  data() {
    return {
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      form: { accept: false },
      ruleText: "",
    };
  },
  mounted() {
    this.getRuleText();
  },
  watch: {},
  computed: {
    formRef() {
      return this.$refs.form;
    },
    isUpdateMode() {
      return this.form.id && this.form.id > 0;
    },
  },
  methods: {
    AcceptRule(value) {
      return (this.form.accept = value ? 0 : 1);
    },
    setInitialValue(data) {
      this.form = data;
    },
    save() {
      return new Promise((resolve, reject) => {
        
          if (this.form.accept) {
            this.$emit("is-loading", true);
            if (this.isUpdateMode) {
              // alert('yes')
            } else {
              supplireApi
                .AcceptingTheRules({
                  accept: this.form.accept,
                })

                .then((res) => {
                  this.form = res.data.entity;
                  this.$emit("on-update", this.form);
                  resolve(true);
                })
                .finally(() => {
                  this.$emit("is-loading", false);
                })
                .catch((err) => {
                  this.setErrors(err.response.data.errors);
                  reject(err);
                });
            }
          } else { 
            this.$izitoast("error", "ابتدا قوانین را خوانده و موافقت نمایید")
          reject(false);
        }
        
      });
    },
    getRuleText() {
      supplireApi.getRuleText().then(({ data }) => {
        this.ruleText = data.entity.content;
      });
    },

    validate() {
      return this.$refs.form.validate();
    },

    setErrors(err) {
      this.$refs.form.setErrors(err);
    },
  },
};
</script>

<style>

.agree-rules-button {
  width: 20px;
  height: 20px;
}

</style>